import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

import { PhoneNumberType, PhoneNumberUtil } from 'google-libphonenumber';
import { translate } from '@ngneat/transloco';

/**
 * Validates that the given phone number is a mobile phone number
 * @private
 */
export function mobilePhoneValidator(): ValidatorFn {
  const phoneUtil = PhoneNumberUtil.getInstance();
  return (control: AbstractControl): ValidationErrors | null => {
    try {
      const parsedPhoneNumber = phoneUtil.parse(control.value);
      const numberType = phoneUtil.getNumberType(parsedPhoneNumber);
      if (numberType === PhoneNumberType.MOBILE || numberType === PhoneNumberType.FIXED_LINE_OR_MOBILE) {
        return null;
      }
      return { mobile: translate('Le numéro de téléphone doit être un numéro mobile valide') }
    } catch (e) {
      return null;
    }
  };
}

/**
 * As Angular Common removes validators of `ik-phone-input` we add it again on form value change.
 * This function should be called in form value change subscription if the field that needs validation is a `ik-phone-input`
 * @param control The phone form field
 */
export function addMobilePhoneValidatorAfterDeletionFromAngularCommon(control: AbstractControl): void {
  if (!control?.hasValidator(mobilePhoneValidator())) {
    control?.addValidators([mobilePhoneValidator()]);
  }
}
